import { isEmptyObject, isInGameBrowser, isMobileOrTabletWindow } from '~/utils/utils';
import { hasAnimationSetting, isDisabledAnimationByName, updateAnimationStatusByName } from '~/utils/animations/settings';
import { State } from '~/Reducers';
import { useSelector } from 'react-redux';
import equal from 'fast-deep-equal/react';
import { UserGraphicsQualityPreset, UserGraphicsQualityPresetTypes } from '@wg/web2clientapi/browser/getUserGraphicsQualityPreset';
import React from 'react';
import { ICurrentPage } from '~/Actions/ActionAppType';

interface IStateSelector {
    categoriesAnimationStatuses: ICategoriesAnimationStatuses;
    userGraphics: UserGraphicsQualityPreset;
    currentPage: ICurrentPage;
}

const stateSelector = (state: State): IStateSelector => {
    return {
        categoriesAnimationStatuses: state.ReducerApp.categoriesAnimationStatuses,
        userGraphics: state.ReducerAccount.userGraphics,
        currentPage: state.ReducerApp.currentPage,
    };
};

export function useDisabledAnimationByGraphics(name: string) {
    const { userGraphics, currentPage } = useSelector<State, IStateSelector>(stateSelector, equal);

    React.useEffect(() => {
        if (!name || hasAnimationSetting(name) || !isInGameBrowser || isEmptyObject(userGraphics)) {
            return;
        }
        if (userGraphics.preset === UserGraphicsQualityPresetTypes.LOW && name) {
            updateAnimationStatusByName(name, true);
        }
    }, [name, currentPage?.name, userGraphics]);
}

export default function (name: string, isDisabledMobileAnimation: boolean = isMobileOrTabletWindow) {
    const { categoriesAnimationStatuses } = useSelector<State, IStateSelector>(stateSelector, equal);
    return isDisabledMobileAnimation || isDisabledAnimationByName(name) || !!categoriesAnimationStatuses?.[name];
}
